import { useContext } from "react";
import { useLocation } from "react-router-dom";
import { RoutedOverlayChainContext } from "./RoutedOverlayChainContext";
import { joinPath } from "./routedOverlayUtils";

/**
 * The current pathname without the drawer levels that a route-aware `DrawerStackProvider`
 * parsed from it. Key page-scoped settings (grid state, saved views) by this so opening a
 * routed drawer does not switch them to a different key.
 */
export const useOverlayHostPathname = (): string => {
  const { pathname } = useLocation();
  const chain = useContext(RoutedOverlayChainContext);
  if (!chain) {
    return pathname;
  }
  // Normalize like `basePath` so a trailing slash keeps the key it has with a drawer open.
  return chain.levels.length > 0 ? chain.basePath : joinPath(pathname);
};
